// extracted by mini-css-extract-plugin
export default {"container":"EK-z","topReviewHeading":"FK-z","criticalReview":"GK-z","favorableReview":"HK-z","vsSeparator":"IK-z"};